import {useState} from "react";
import {Link} from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import AuthLayout from "../components/AuthLayout";
import {Alert, Input, buttonClass} from "../components/ui";

const Login = () => {
    
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        setMessage(null);
        setErrorMessage(null);
        e.preventDefault();
        try {
            setLoading(true);
            await axiosInstance.post("/auth/request-reset-password", {
                email: email,
            });
            setMessage("Reset link has been sent to your email.");
            setLoading(false);
            setEmail("");
        } catch (err) {
            setLoading(false);
            if (err.response.status === 400) {
                setErrorMessage(err.response.data.message);
                return;
            }
            setErrorMessage("There was a problem sending the reset link.");
        }
    };

    return (
        <AuthLayout
            title="Forgot password"
            subtitle="Enter your email and we'll send you a reset link."
        >
            {message && <Alert tone="success" className="mb-4">{message}</Alert>}
            {errorMessage && <Alert tone="error" className="mb-4">{errorMessage}</Alert>}

            <form onSubmit={handleSubmit} className="space-y-3">
                <Input
                    type="email"
                    placeholder="Email"
                    value={email}
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button className={buttonClass({className: "w-full"})} disabled={loading}>
                    {loading ? "Sending…" : "Reset Password"}
                </button>
            </form>

            <p className="mt-5 text-center text-sm text-gray-500 dark:text-slate-400">
                Back to{" "}
                <Link
                    to={`/login`}
                    className="font-semibold text-red-600 transition hover:text-red-500 dark:text-orange-400"
                >
                    Login
                </Link>
            </p>
        </AuthLayout>
    );
};

export default Login;
